<template>
  <div class="doctor-hover-calendar bg-white" v-if="doctor">
    <div class="row align-items-center no-gutters">
      <div class="col col-auto">
        <img class="round-img mr-2" :src="doctor.photo"/>
      </div>
      <div class="col">
        <div class="doctor-title">{{ doctor.full_name }}</div>
        <div class="text-muted">{{ times }}</div>
      </div>
    </div>
    <div class="position-relative">
      <b-spinner v-if="loading" class="position-absolute" style="left: 50%; top: 50%; margin-left: -23px; margin-top: -23px; z-index: 5"></b-spinner>
      <VCalendar class="mt-3"
                 v-if="initiated"
                 ref="datepicker"
                 :locale="{ id: 'ru', firstDayOfWeek: 2, masks: { L: 'DD.MM.YYYY' } }"
                 borderless
                 expanded
                 @update:pages="fromPage"
                 @did-move="pageChange"
                 :initial-page="initialDate"
                 :model-value="date"
                 @update:model-value="date = $event">
        <template #day-content="{day}">
          <div v-if="day"
               class="vc-day-content position-relative"
               :class="{
                'text-muted': !fillData[day.label],
                'workDay': !loading && workDays.includes(Number(day.label))
               }"
               @click="dayClicked(day)">
            <span class="position-relative day-title">{{ day.label }}</span>
            <div class="availability-column"
                 v-if="fillData[day.label] && !loading"
                 :style="{ height: fillData[day.label]+'%' }"></div>
          </div>
        </template>
      </VCalendar>
    </div>
  </div>
</template>

<script>
import { Calendar } from 'v-calendar'
import moment from "moment"
import { DoctorService } from "@/services/api/doctor.api.service"

export default {
  name: "DoctorHoverCalendar",
  components: {
    VCalendar: Calendar
  },
  props: {
    doctor: {
      type: Object
    },
    chair: {
      type: Object
    },
    day: {}
  },
  data() {
    return {
      date: moment(this.day).format('YYYY-MM'),
      fillData: {},
      workDays: [],
      loading: false,
      dayLoaded: moment(this.day).format('YYYY-MM'),
      initiated: false,
      initialDate: {},
      lastPage: null
    }
  },
  computed: {
    doctorSchedules() {
      return this.$store.state.calendar.doctorSchedules
    },
    branchId() {
      return this.$store.state.auth.branch
    },
    times() {
      const day = moment(this.day).format('YYYY-MM-DD')
      if(!this.doctorSchedules) return []
      return this.doctorSchedules[this.doctor.id]?.filter(s => (this.chair ? Number(s.chair_id) === this.chair.id : true) && s.day === day)
          .map(s => `${s.time_from.slice(0, -3)} - ${s.timeToAdjusted.slice(0, -3)}`)
          .join(', ')
    },
  },
  methods: {
    changeCalendarDays() {
      this.$store.commit('changeCalendarDays', this.date)
    },
    fromPage(val) {
      const id = val?.[0]?.id || null
      if(id) {
        if(this.lastPage !== id) {
          this.workDays = []
          this.fillData = {}
        }
        this.lastPage = id
      }
    },
    async load(day) {
      if(!this.doctor) return
      this.loading = true
      this.dayLoaded = day
      this.workDays = []
      this.fillData = {}
      try {
        const res = await DoctorService.monthAvailabilityDetailed(this.doctor.id, this.branchId, day)
        this.fillData = res.data?.availability || {}
        this.workDays = res.data?.work_days || []
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    pageChange(e) {
      const day = `${e[0].year}-${e[0].month.toString().padStart(2, '0')}`
      if(this.dayLoaded !== day) {
        this.load(day)
      }
    },
    dayClicked(e) {
      this.$store.commit('goToDate', moment(e.date))
    },
  },
  mounted() {
    this.fillData = {}
    this.load(this.dayLoaded)
    this.initialDate = {
      month: moment(this.day).format('MM'),
      year: moment(this.day).format('YYYY')
    }
    this.initiated = true
  }
}
</script>

<style scoped lang="scss">

.doctor-hover-calendar {
  padding: 6px;
  box-shadow: 0 0 10px 0 rgba(0,0,0,.15);
  background: #fff;
  border-radius: 12px;
  img {
    width: 64px;
  }
  .doctor-title {
    font-weight: 700;
    font-size: 14px;
  }
  .day-title {
    z-index: 2;
  }
  .availability-column {
    position: absolute;
    z-index: 1;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #C1ECA6;
  }
}
::v-deep .vc-highlights {
  display: none;
}
::v-deep .vc-day-content:hover {
  background-color: transparent;
}
.workDay {
  border: 1px solid #C1ECA6;
  border-radius: 6px;
  overflow: hidden;
}
</style>
